import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {OAuthService} from 'angular-oauth2-oidc-codeflow';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

const endpoint = environment.capaApiUrl;
const defaultVersion = environment.capaApiVersionDefault;

@Injectable()
export class ApiCapaService {

    constructor(private oAuthService: OAuthService, private httpClient: HttpClient) {

    }

    public get(methodApi: string, apiVersion: string = null): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + this.oAuthService.getAccessToken())
            .set('Access-Control-Allow-Origin', '*')
            .set('Content-Type',  'application/json');
        if (apiVersion == null) {
            apiVersion = defaultVersion;
        }
        return this.httpClient.get(endpoint + apiVersion + '/' +  methodApi, {headers});
    }

    public post(methodApi: string, body: any | null, apiVersion: string = null): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + this.oAuthService.getAccessToken())
            .set('Access-Control-Allow-Origin', '*')
            .set('Content-Type',  'application/json')
            .set('Accept', 'application/json');
        if (apiVersion == null) {
            apiVersion = defaultVersion;
        }
        return this.httpClient.post(endpoint + apiVersion + '/' + methodApi, body, {headers});
    }

    public put(methodApi: string, body: any | null, apiVersion: string = null): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + this.oAuthService.getAccessToken())
            .set('Access-Control-Allow-Origin', '*')
            .set('Content-Type',  'application/json')
            .set('Accept', 'application/json');
        if (apiVersion == null) {
            apiVersion = defaultVersion;
        }
        return this.httpClient.put(endpoint + apiVersion + '/' + methodApi, body, {headers});
    }

    public delete(methodApi: string, body: any | null, apiVersion: string = null): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + this.oAuthService.getAccessToken())
            .set('Access-Control-Allow-Origin', '*')
            .set('Content-Type',  'application/json')
            .set('Accept', 'application/json');
        if (apiVersion == null) {
            apiVersion = defaultVersion;
        }
        return this.httpClient.request('delete', endpoint + apiVersion + '/' + methodApi, {headers, body});
    }
}
